import { useEffect, useRef, useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import './resource.css';
import './selected-domains.css';
import ConfirmDeleteModal2 from "../../../components/DeletAssitant";
import { AuthContext } from "../../../authContext";
import LoadingSpinner from '../../../components/LoadingSpinner';
import AlertsCustom from '../../../components/Alerts';
import ResourceLayout from './ResouceLayout';



const domains = [
  { id: 1, name: 'OpenAI' },
  { id: 2, name: 'Gemini' },
  { id: 3, name: 'Mistral' },
  { id: 4, name: 'Processamento PDF' },
  //{ id: 5, name: 'Vectorstore' },
  //{ id: 6, name: 'Storage Account' },
  //{ id: 7, name: 'Budcar na web' },
  //{ id: 8, name: 'Processamento de imagens' },
  { id: 9, name: 'Self Assistant' },
  { id: 10, name: 'Classificador' }
];

const resourceConfig = {
  'OpenAI': {
    fields: ['openai_endpoint', 'api_key'],
    models: [
      { id: 1, name: 'GPT-4o', valueLabel: 'Deployment' },
      { id: 2, name: 'GPT-4o-Mini', valueLabel: 'Deployment' },
      { id: 3, name: 'GPT-4.1', valueLabel: 'Deployment' },
    ]
  },
  'Gemini': {
    fields: ['key_gemini']
  },
  'Mistral': {
    fields: ['url', 'key'],
    models: [
      { id: 4, name: 'Mistral Small' },
      { id: 5, name: 'Mistral Large' }
    ]
  },
  'Processamento PDF': {
    fields: ['connection_string', 'key_gemini', 'container_name']
  },
  /*'Budcar na web': {
    fields: ['key_gemini']
  },
  'Processamento de imagens': {
    fields: ['openai_key', 'endpoint'],
    models: [
      { id: 1, name: 'GPT-4o', valueLabel: 'Deployment' },
      { id: 2, name: 'GPT-4o-Mini', valueLabel: 'Deployment' },
      { id: 3, name: 'GPT-4.1', valueLabel: 'Deployment' },
    ]
  },*/
  'Self Assistant': {
    fields: ['search_key', 'endpoint', 'index', 'openai_endpoint', 'api_key', 'deployment']
  },
  'Classificador': {
    fields: ['key_gemini', 'api_key', 'deployment', 'endpoint', 'container_name', 'connection_string', 'function_url', 'function_key']
  },
};


function ResourceContent({ searchTerm: initialSearchTerm = "" }) {
  const [searchTerm, setSearchTerm] = useState(initialSearchTerm);
  // Estado para controlar se o botão deve ser bloqueado após tentativa inválida
  const [blockModelSave, setBlockModelSave] = useState({});
  const [blockPopupSave, setBlockPopupSave] = useState(false);
  const { t: tResource } = useTranslation('resource');
  const { accessToken, sessionId, level, domainsAccess } = useContext(AuthContext);
  const [isHovered, setIsHovered] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [showResourcePopup, setShowResourcePopup] = useState(false);
  const [expandedCards, setExpandedCards] = useState({});
  const [showModelSection, setShowModelSection] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [resourceToDelete, setResourceToDelete] = useState(null);
  const [hiddenDefaultResources, setHiddenDefaultResources] = useState({});
  const [isDeleteCardModalOpen, setIsDeleteCardModalOpen] = useState(false);
  const [cardToDelete, setCardToDelete] = useState(null);
  const [selectedModels, setSelectedModels] = useState({});
  const [openCountryDropdown, setOpenCountryDropdown] = useState({});
  const [activeCountry, setActiveCountry] = useState({});
  const [domainSelections, setDomainSelections] = useState({});
  const dropdownRefs = useRef({});
  const [openPopupDropdown, setOpenPopupDropdown] = useState(false);
  const [activePopupCountry, setActivePopupCountry] = useState(null);
  const [popupDomainSelections, setPopupDomainSelections] = useState([]);
  const popupDropdownRef = useRef(null);
  const [newBuName, setNewBuName] = useState('');
  const [selectedPopupResources, setSelectedPopupResources] = useState([]); // OpenAI sempre selecionado por padrão
  const [formTocado, setFormTocado] = useState(false);
  const [isSavingBu, setIsSavingBu] = useState(false);
  const [editingCardId, setEditingCardId] = useState(null);
  const [newResourceSelections, setNewResourceSelections] = useState([]);
  const [dynamicResources, setDynamicResources] = useState({});
  const [isSavingResources, setIsSavingResources] = useState(false);
  const [resourceUsers, setResourceUsers] = useState([]);
  const [resourceFields, setResourceFields] = useState({});
  const [resourceActivation, setResourceActivation] = useState({});
  const [resourceListError, setResourceListError] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [resourcePopupAttemptedSubmit, setResourcePopupAttemptedSubmit] = useState(false);
  const [alertTitle, setAlertTitle] = useState("");
  const [alertType, setAlertType] = useState("");
  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [availableDomains, setAvailableDomains] = useState([]);

  // Local persistence for optimistic activation state so UI doesn't wait backend
  const ACTIVATION_OVERRIDES_KEY = 'resourceActivationOverrides';

  useEffect(() => {
    const fetchDomains = async () => {
      if (!accessToken) return;
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/get_domains`, {
          headers: { 'Authorization': `Bearer ${accessToken}` }
        });
        const data = await res.json();
        const mapped = data.map((d) => ({
          id: d.dominio,
          name: d.dominio
        }));
        setAvailableDomains(mapped);
      } catch (e) {
        console.error('Erro ao carregar domínios:', e);
      }
    };
    fetchDomains();
  }, [accessToken]);

  const getActivationOverrides = () => {
    try {
      const raw = localStorage.getItem(ACTIVATION_OVERRIDES_KEY);
      if (!raw) return {};
      return JSON.parse(raw) || {};
    } catch (e) {
      console.warn('Failed to read activation overrides from localStorage', e);
      return {};
    }
  };


  const setActivationOverride = (resourceId, value) => {
    try {
      const current = getActivationOverrides();
      current[resourceId] = !!value;
      localStorage.setItem(ACTIVATION_OVERRIDES_KEY, JSON.stringify(current));
    } catch (e) {
      console.warn('Failed to write activation override to localStorage', e);
    }
  };

  const removeActivationOverride = (resourceId) => {
    try {
      const current = getActivationOverrides();
      if (current.hasOwnProperty(resourceId)) {
        delete current[resourceId];
        localStorage.setItem(ACTIVATION_OVERRIDES_KEY, JSON.stringify(current));
      }
    } catch (e) {
      console.warn('Failed to remove activation override from localStorage', e);
    }
  };

  const removeActivationOverridesByCard = (cardId) => {
    try {
      const current = getActivationOverrides();
      let changed = false;
      Object.keys(current).forEach(key => {
        // resource ids include the cardId (ex: llm-<cardId>-idx, vectorstore-<cardId>, storage-<cardId>)
        if (key.indexOf(`-${cardId}`) >= 0) {
          delete current[key];
          changed = true;
        }
      });
      if (changed) localStorage.setItem(ACTIVATION_OVERRIDES_KEY, JSON.stringify(current));
    } catch (e) {
      console.warn('Failed to remove activation overrides by card from localStorage', e);
    }
  };


  useEffect(() => {
    const handleClickOutside = (e) => {
      Object.entries(dropdownRefs.current).forEach(([cardId, ref]) => {
        if (ref && !ref.contains(e.target)) {
          setOpenCountryDropdown(prev => ({ ...prev, [cardId]: false }));
          setActiveCountry(prev => ({ ...prev, [cardId]: undefined }));
        }
      });

      if (popupDropdownRef.current && !popupDropdownRef.current.contains(e.target)) {
        setOpenPopupDropdown(false);
        setActivePopupCountry(null);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Load resource groups from backend
  useEffect(() => {
    const fetchResourceGroups = async () => {
      if (!accessToken) return;
      setIsLoading(true);
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/get_all_resource_group`, {
          method: 'GET',
          headers: { 'Authorization': `Bearer ${accessToken}` },
        });
        const data = await res.json();
        const groups = (data?.resource_group || [])
          .filter((g) => {
            // Se for o recurso básico, só permite passar se o level for 'dev'
            if (g.basic) return level === 'dev';
            return true; // Outros recursos passam normalmente
          })
          .map((g) => ({
            id: g._id,
            name: g.name || g.nome || 'Resource Group',
            isBasic: !!g.basic // Guardamos essa flag para usar na UI
          }))
          .sort((a, b) => {
            // Força o recurso básico a ficar sempre no índice 0 (topo)
            if (a.isBasic && !b.isBasic) return -1;
            if (!a.isBasic && b.isBasic) return 1;
            return 0; // O restante mantém a ordem original
          });
        setResourceUsers(groups);

        // hydrate optional fields

        const nextDomain = {};
        const nextHiddenDefault = {};
        const nextDynamic = {};
        const nextResourceFields = {};
        const nextSelectedModels = {};
        const nextResourceActivation = {};

        (data?.resource_group || []).forEach((g) => {
          const cardId = g._id;

          if (g.domains && Array.isArray(g.domains)) {
            nextDomain[cardId] = g.domains; // array plano direto
          }

          if (g.hideDefault != null) nextHiddenDefault[cardId] = !!g.hideDefault;

          const reconstructedResources = [];

          if (g.pdf_processing) {
            const resourceId = `pdf-${cardId}`;
            reconstructedResources.push({ id: resourceId, name: 'Processamento PDF' });
            const resourceKey = `${cardId}-${resourceId}`;
            nextResourceFields[resourceKey] = { connection_string: g.pdf_processing.connection_string };
            nextResourceFields[resourceKey].container_name = g.pdf_processing.container_name;
            nextResourceFields[resourceKey].key_gemini = g.pdf_processing.key_gemini;
            nextResourceActivation[resourceId] = g.pdf_processing.status || false;
          }
          if (g.openai) {
            const resourceId = `openai-${cardId}`;
            reconstructedResources.push({ id: resourceId, name: 'OpenAI' });
            const resourceKey = `${cardId}-${resourceId}`;
            nextResourceFields[resourceKey] = {   // ← inicializa primeiro
              openai_endpoint: g.openai.openai_endpoint,
              api_key: g.openai.api_key,
            };
            nextResourceFields[resourceKey].openai_endpoint = g.openai.openai_endpoint;
            nextResourceFields[resourceKey].api_key = g.openai.api_key;
            nextResourceActivation[resourceId] = g.openai.status || false;
            // reconstruir modelos
            const modelMap = (g.openai.models || []).reduce((acc, m) => {
              const model = resourceConfig['OpenAI'].models.find(
                mod => mod.name.toLowerCase().replace(/ /g, '-') === m.name
              );
              if (model) acc[model.id] = { selected: true, value: m.deployment };
              return acc;
            }, {});
            nextSelectedModels[`${cardId}-${resourceId}`] = modelMap;
          }

          if (g.gemini) {
            const resourceId = `gemini-${cardId}`;
            reconstructedResources.push({ id: resourceId, name: 'Gemini' });
            const resourceKey = `${cardId}-${resourceId}`;
            nextResourceFields[resourceKey] = {   // ← inicializa primeiro
              key_gemini: g.gemini.key_gemini,
            };
            nextResourceFields[resourceKey].key_gemini = g.gemini.key_gemini;
            nextResourceActivation[resourceId] = g.gemini.status || false;
          }

          if (g.mistral) {
            const resourceId = `mistral-${cardId}`;
            reconstructedResources.push({ id: resourceId, name: 'Mistral' });
            nextResourceFields[`${cardId}-${resourceId}`] = {
              url: g.mistral.url,
              key: g.mistral.key,
            };
            nextResourceActivation[resourceId] = g.mistral.status || false;
          }
          if (g.self_assistant) {
            const resourceId = `selfassistant-${cardId}`;
            reconstructedResources.push({ id: resourceId, name: 'Self Assistant' });
            const resourceKey = `${cardId}-${resourceId}`;
            nextResourceFields[resourceKey] = {};
            nextResourceFields[resourceKey].endpoint = g.self_assistant.endpoint;
            nextResourceFields[resourceKey].search_key = g.self_assistant.search_key;
            nextResourceFields[resourceKey].index = g.self_assistant.index;
            nextResourceFields[resourceKey].openai_endpoint = g.self_assistant.openai_endpoint;
            nextResourceFields[resourceKey].api_key = g.self_assistant.api_key;
            nextResourceFields[resourceKey].deployment = g.self_assistant.deployment;
            nextResourceActivation[resourceId] = g.self_assistant.status || false;
          }
          if (g.classifier) {
            const resourceId = `classifier-${cardId}`;
            reconstructedResources.push({ id: resourceId, name: 'Classificador' });
            const resourceKey = `${cardId}-${resourceId}`;
            nextResourceFields[resourceKey] = {};
            nextResourceFields[resourceKey].openai_endpoint = g.classifier.openai_endpoint;
            nextResourceFields[resourceKey].api_key = g.classifier.api_key;
            nextResourceFields[resourceKey].deployment = g.classifier.deployment;
            nextResourceFields[resourceKey].key_gemini = g.classifier.key_gemini;
            nextResourceFields[resourceKey] = { connection_string: g.classifier.connection_string };
            nextResourceFields[resourceKey].container_name = g.classifier.container_name;
            nextResourceFields[resourceKey] = { function_key: g.classifier.function_key };
            nextResourceFields[resourceKey].function_url = g.classifier.function_url;
            nextResourceActivation[resourceId] = g.classifier.status || false;
          }

          if (reconstructedResources.length > 0) {
            nextDynamic[cardId] = reconstructedResources;
          } else if (Array.isArray(g.resources)) {
            nextDynamic[cardId] = g.resources;
          }
        });


        if (Object.keys(nextDomain).length) setDomainSelections((p) => ({ ...p, ...nextDomain }));
        if (Object.keys(nextHiddenDefault).length) setHiddenDefaultResources((p) => ({ ...p, ...nextHiddenDefault }));
        if (Object.keys(nextDynamic).length) setDynamicResources((p) => ({ ...p, ...nextDynamic }));
        if (Object.keys(nextResourceFields).length) setResourceFields((p) => ({ ...p, ...nextResourceFields }));
        if (Object.keys(nextSelectedModels).length) setSelectedModels((p) => ({ ...p, ...nextSelectedModels }));
        // Merge persisted overrides from localStorage so UI reflects optimistic toggles
        const overrides = getActivationOverrides();
        const mergedActivation = { ...nextResourceActivation, ...overrides };
        if (Object.keys(mergedActivation).length) setResourceActivation((p) => ({ ...p, ...mergedActivation }));
      } catch (e) {
        console.error('Erro ao carregar resource groups:', e);
      } finally {
        setIsLoading(false);
      }
    };
    fetchResourceGroups();
  }, [accessToken]);


  // Persist updates to a resource group - MODIFICADO PARA O NOVO FORMATO
  const saveGroup = async (groupId, extra = {}) => {
    try {
      // Converte domainSelections para array plano
      const domainsArray = domainSelections[groupId] || [];

      const activationOverrides = getActivationOverrides();
      // Processa recursos dinâmicos para o novo formato
      const userResources = extra.resources !== undefined ? extra.resources : (dynamicResources[groupId] || []);
      const llmArray = [];
      let vectorstoreObj = null;
      let storageAccountObj = null;
      let pdfProcessingObj = null;
      let webSearchObj = null;
      let imageProcessingObj = null;
      let selfAssistantObj = null;
      let classifierObj = null;
      let openaiObj = null;
      let geminiObj = null;
      let mistralObj = null;


      userResources.forEach(resource => {
        const resourceKey = `${groupId}-${resource.id}`;
        const fields = resourceFields[resourceKey] || {};
        const models_obj = selectedModels[resourceKey] || {};
        const isActive = (activationOverrides.hasOwnProperty(resource.id))
          ? activationOverrides[resource.id]
          : (resourceActivation[resource.id] || false);

        const modelValues = Object.entries(models_obj)
          .filter(([, m]) => m?.value && m.value.trim() !== '')
          .map(([modelId, m]) => {
            const resourceConfig_item = resourceConfig[resource.name]; // ← busca pelo nome do recurso
            const modelInfo = resourceConfig_item?.models?.find(mod => mod.id === Number(modelId));
            return {
              name: modelInfo?.name?.toLowerCase().replace(/ /g, '-') || modelId,
              deployment: m.value
            };
          });



        if (resource.name === 'OpenAI') {
          openaiObj = {
            openai_endpoint: fields['openai_endpoint'] || null,
            api_key: fields['api_key'] || null,
            deployment: fields['deployment'] || null,
            models: modelValues,
            status: isActive
          };
        }
        else if (resource.name === 'Gemini') {
          geminiObj = {
            key_gemini: fields['key_gemini'] || null,
            status: isActive
          };
        }
        else if (resource.name === 'Mistral') {
          mistralObj = {
            url: fields.url || null,
            key: fields.key || null,
            status: isActive,
          }
        }
        else if (resource.name === 'Processamento PDF') {

          pdfProcessingObj = {
            connection_string: fields['connection_string'] || null,
            container_name: fields['container_name'] || null,
            key_gemini: fields['key_gemini'] || null,
            models: modelValues,
            status: isActive
          };

        }
        else if (resource.name === 'Self Assistant') {

          selfAssistantObj = {
            search_key: fields['search_key'] || null,
            index: fields['index'] || null,
            endpoint: fields['endpoint'] || null,
            openai_endpoint: fields['openai_endpoint'] || null,
            api_key: fields['api_key'] || null,
            deployment: fields['deployment'] || null,
            status: isActive
          };

        } else if (resource.name === 'Classificador') {

          classifierObj = {
            connection_string: fields['connection_string'] || null,
            container_name: fields['container_name'] || null,
            key_gemini: fields['key_gemini'] || null,
            openai_endpoint: fields['openai_endpoint'] || null,
            api_key: fields['api_key'] || null,
            deployment: fields['deployment'] || null,
            function_key: fields['function_key'] || null,
            function_url: fields['function_url'] || null,
            models: modelValues,
            status: isActive
          };

        }
      });

      const updated_data = {
        name: resourceUsers.find((u) => u.id === groupId)?.name,
        domains: domainsArray,
        vectorstore: vectorstoreObj,
        storage_account: storageAccountObj,
        pdf_processing: pdfProcessingObj,
        web_search: webSearchObj,
        image_processing: imageProcessingObj,
        self_assistant: selfAssistantObj,
        classifier: classifierObj,
        openai: openaiObj,
        gemini: geminiObj,
        mistral: mistralObj,
        ...extra,
      };

      if (extra.resources !== undefined) {
        delete updated_data.resources;
      }

      const res = await fetch(`${process.env.REACT_APP_API_URL}/put_resource_group`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${accessToken}` },
        body: JSON.stringify({ session_id: sessionId, resource_id: groupId, updated_data })
      });
      if (!res.ok) {
        const text = await res.text();
        const err = new Error(`PUT failed: ${text}`);
        err.response = res;
        throw err;
      }
      return res;
    } catch (e) {
      console.error('Erro ao salvar resource group:', e);
      throw e;
    }
  };


  const handleExitPopup = () => {
    setShowPopup(false);
    setOpenPopupDropdown(false);
    setActivePopupCountry(null);
    setPopupDomainSelections([]);
    setNewBuName('');
    setSelectedPopupResources([]); // Reset para OpenAI sempre selecionado
    setFormTocado(false);
    setBlockPopupSave(false); // Reset do bloqueio do botão
  };

  const handleExitResourcePopup = () => {
    setShowResourcePopup(false);
    setEditingCardId(null);
    setNewResourceSelections([]);
    setResourceListError(false);
    setResourcePopupAttemptedSubmit(false); // Reset do estado de tentativa de envio
  };

  const handleExitModelSection = () => {
    setShowModelSection(null);
  };

  const handleOpenModelSection = (cardId, resourceId = null) => {
    const sectionId = `${cardId}-${resourceId}`;
    const resourceKey = `${cardId}-${resourceId}`;
    setShowModelSection(sectionId);

    // Limpa o erro de validação do modelo ao abrir a seleção
    if (validationErrors[resourceKey]?.models) {
      setValidationErrors(prev => {
        const newErrors = { ...prev[resourceKey] };
        delete newErrors.models;
        return {
          ...prev,
          [resourceKey]: newErrors,
        };
      });
    }
  };



  const handleModelValueChange = (resourceKey, modelId, value) => {
    setSelectedModels((prev) => ({
      ...prev,
      [resourceKey]: {
        ...prev[resourceKey],
        [modelId]: {
          selected: !!value, // considerado selecionado se tiver valor
          value,
        },
      },
    }));
  };


  const toggleCardExpansion = (cardId) => {
    const isCurrentlyExpanded = !!expandedCards[cardId];

    // Se o card está expandido e será fechado, limpa os erros e bloqueios
    if (isCurrentlyExpanded) {
      // Resetar validationErrors para o card específico
      setValidationErrors(prev => {
        const next = { ...prev };
        Object.keys(next).forEach(key => {
          if (key.startsWith(`${cardId}-`)) {
            delete next[key];
          }
        });
        return next;
      });

      // Resetar blockModelSave para o card específico
      setBlockModelSave(prev => {
        const next = { ...prev };
        Object.keys(next).forEach(key => {
          if (key.startsWith(`${cardId}-`)) {
            delete next[key];
          }
        });
        return next;
      });
    }

    setExpandedCards(prev => ({
      ...prev,
      [cardId]: !prev[cardId]
    }));
  };

  const togglePopupDropdown = () => {
    setOpenPopupDropdown(prev => !prev);
  };

  const togglePopupDomainSelection = (domainId) => {
    setPopupDomainSelections(prev =>
      prev.includes(domainId)
        ? prev.filter(id => id !== domainId)
        : [...prev, domainId]
    );
  };





  // MODIFICADO - handleAddBusinessUnit para usar o novo formato
  const handleAddBusinessUnit = async () => {
    if (isSavingBu) return;

    setFormTocado(true);

    const isDomainSelected = popupDomainSelections.length > 0;
    const isResourceSelected = selectedPopupResources.length > 0;
    const isNameFilled = newBuName.trim() !== '';

    if (!isNameFilled || !isDomainSelected || !isResourceSelected) {
      return;
    }

    setIsSavingBu(true);

    // Converte domainSelections para array plano
    const domainsArray = popupDomainSelections;

    // Cria os recursos no novo formato
    const llmArray = [];
    let vectorstoreObj = null;
    let storageAccountObj = null;
    let pdfProcessingObj = null;
    let webSearchObj = null;
    let imageProcessingObj = null;
    let selfAssistantObj = null;
    let classifierObj = null;
    let openaiObj = null;
    let geminiObj = null;
    let mistralObj = null;


    selectedPopupResources.forEach(resourceId => {
      const resourceInfo = domains.find(d => d.id === resourceId);
      if (!resourceInfo) return;


      /*else if (resourceInfo.name === 'Vectorstore') {
        vectorstoreObj = {
          url: null,
          key: null,
          status: false
        };
      } 
      else if (resourceInfo.name === 'Storage Account') {
        storageAccountObj = {
          connexion_string: null,
          status: false
        };
      } */
      if (resourceInfo.name === 'OpenAI') {
        openaiObj = {
          api_key: null,
          openai_endpoint: null,
          deployment: null,
          models: [],
          status: false
        }
      } else if (resourceInfo.name === 'Gemini') {
        geminiObj = {
          key_gemini: null,
        }
      } else if (resourceInfo.name === 'Mistral') {
        mistralObj = {
          url: null,
          key: null,
        }
      }
      else if (resourceInfo.name === 'Processamento PDF') {
        pdfProcessingObj = {
          connection_string: null,
          container_name: null,
          key_gemini: null,
          status: false
        }
      }
      else if (resourceInfo.name === 'Self Assistant') {
        selfAssistantObj = {
          search_key: null,
          index: null,
          endpoint: null,
          openai_endpoint: null,
          api_key: null,
          deployment: null,
          status: false
        }
      } else if (resourceInfo.name === 'Classificador') {
        classifierObj = {
          key_gemini: null,
          connection_string: null,
          container_name: null,
          openai_endpoint: null,
          api_key: null,
          deployment: null,
          function_key: null,
          function_url: null,
          status: false
        }
      }
    });

    // Também mantém o formato antigo nos estados locais para compatibilidade com a UI
    const newResources = selectedPopupResources.map(resourceId => {
      const resourceInfo = domains.find(d => d.id === resourceId);
      return {
        id: `dynamic-${Date.now()}-${resourceId}`,
        name: resourceInfo?.name || String(resourceId),
      };
    });

    try {
      const payload = {
        session_id: sessionId,
        data: {
          name: newBuName,
          domains: domainsArray,
          vectorstore: vectorstoreObj,
          storage_account: storageAccountObj,
          pdf_processing: pdfProcessingObj,
          web_search: webSearchObj,
          image_processing: imageProcessingObj,
          self_assistant: selfAssistantObj,
          classifier: classifierObj,
          openai: openaiObj,
          gemini: geminiObj,
          mistral: mistralObj,
          created_at: new Date().toISOString(),
        }
      };

      const res = await fetch(`${process.env.REACT_APP_API_URL}/post_resource_group`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${accessToken}` },
        body: JSON.stringify(payload)
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data?.response || 'Falha ao criar recurso');

      const newId = data?._id;
      const newBu = { id: newId, name: newBuName };
      setDomainSelections(prev => ({ ...prev, [newId]: popupDomainSelections }));
      setDynamicResources(prev => ({ ...prev, [newId]: newResources }));
      setHiddenDefaultResources(prev => ({ ...prev, [newId]: true }));
      setResourceUsers(prev => [...prev, newBu]);
      // Adiciona esta linha para expandir o card automaticamente após a criação
      setExpandedCards(prev => ({ ...prev, [newId]: true }));
      handleExitPopup();
    } catch (e) {
      console.error('Erro ao criar resource group:', e);
    } finally {
      setIsSavingBu(false);
    }
  };

  const handleVerifyAndSaveResource = async (userId, resource) => {
    const resourceName = resource.name;
    const resourceData = resourceFields[`${userId}-${resource.id}`] || {};

    setIsSavingBu(true);

    let rota = '';
    let payload = {};
    let rota2 = '';
    let payload2 = {};

    if (resourceName === 'Self Assistant') {
      rota = "/post_index_exists";
      payload = {
        endpoint: resourceData.endpoint,
        search_key: resourceData.search_key,
        index: resourceData.index,
      };
      rota2 = "/post_openai_models";
      payload2 = {
        api_key: resourceData.api_key,
        openai_endpoint: resourceData.openai_endpoint,
        model_type: "embeddings",
        deployment: resourceData.deployment,
      }
    } else if (resourceName === 'Processamento PDF') {
      rota = "/post_blob_exists";
      payload = {
        connection_string: resourceData.connection_string,
        container_name: resourceData.container_name
      }
      rota2 = "/post_gemini_models";
      payload2 = {
        api_key: resourceData.key_gemini
      }
    }
    else if (resourceName === 'Gemini') {
      rota = "/post_gemini_models";
      payload = {
        api_key: resourceData.key_gemini,
      }
    } else if (resourceName === 'OpenAI') {
      rota = "/post_openai_models";
      payload = {
        api_key: resourceData.api_key,
        openai_endpoint: resourceData.openai_endpoint,
        models: Object.entries(selectedModels[`${userId}-${resource.id}`] || {})
          .filter(([, m]) => m?.value?.trim())
          .map(([, m]) => m.value),
        model_type: "chat"
      }
    } else if (resourceName === 'Classificador') {
      if (!resourceData) {
        console.error("resourceData está vazio!");
        return;
      }
      rota = "/post_classificador_verify";
      const {
        connection_string,
        container_name,
        key_gemini,
        api_key,
        endpoint,
        deployment,
        function_key,
        function_url
      } = resourceData;

      payload = {
        connection_string: connection_string || "",
        container_name: container_name || "",
        key_gemini: key_gemini || "",
        api_key: api_key || "",
        endpoint: endpoint || "",
        deployment: deployment || "",
        function_key: function_key || "",
        function_url: function_url || ""
      };
    }
    else {
      handleSaveResource(userId, resource);
    }

    try {
      let response2 = { ok: true }; // Default para casos sem segunda validação
      const response = await fetch(`${process.env.REACT_APP_API_URL}${rota}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${accessToken}` },
        body: JSON.stringify(payload)
      });

      if (response.ok && rota2) {
        response2 = await fetch(`${process.env.REACT_APP_API_URL}${rota2}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${accessToken}` },
          body: JSON.stringify(payload2)
        });
        if (!response2.ok) {
          const errorData2 = await response2.json();
          console.error(`Failed to verify ${resourceName} secondary validation:`, errorData2);
          setIsSavingBu(false);

          setAlertTitle("Erro");
          setAlertType("error")
          setAlertMessage(tResource("message_error_key"));
          setShowAlert(true);
          return;
        }
      }


      if (response.ok && response2.ok) {
        handleSaveResource(userId, resource);
        setIsSavingBu(false);
      } else {
        const errorData = await response.json();
        console.error(`Failed to verify ${resourceName} keys:`, errorData);
        setIsSavingBu(false);

        setAlertTitle("Erro");
        setAlertType("error")
        setAlertMessage(tResource("message_error_key"));
        setShowAlert(true);

      }

    } catch (error) {
      console.error('Erro ao verificar e salvar recurso:', error);
      setIsSavingBu(false);
      throw error;
    }

  }

  const handleAddResources = () => {
    if (isSavingResources) return;

    // Marca que o usuário tentou submeter
    setResourcePopupAttemptedSubmit(true);

    if (newResourceSelections.length === 0) {
      setResourceListError(true);
      return;
    }

    setResourceListError(false);
    setIsSavingResources(true);

    const newResources = newResourceSelections.map(resourceId => {
      const resourceInfo = domains.find(d => d.id === resourceId);
      return {
        id: `dynamic-${editingCardId}-${Date.now()}-${resourceId}`,
        name: resourceInfo.name,
      };
    });

    try {
      setDynamicResources(prev => {
        const next = { ...(prev || {}) };
        next[editingCardId] = [...(prev[editingCardId] || []), ...newResources];
        saveGroup(editingCardId, { resources: next[editingCardId] });
        return next;
      });

      handleExitResourcePopup();
    } catch (e) {
      console.error('Erro ao adicionar recursos:', e);
    } finally {
      setIsSavingResources(false);
    }
  };

  const handleDeleteResource = (cardId, resourceId, isDefault = false) => {
    setResourceToDelete({ cardId, resourceId, isDefault });
    setIsDeleteModalOpen(true);
  };

  const handleDeleteCard = (cardId) => {
    setCardToDelete(cardId);
    setIsDeleteCardModalOpen(true);
  };

  const handleCloseDeleteModal = () => {
    setIsDeleteModalOpen(false);
    setResourceToDelete(null);
  };

  const handleCloseDeleteCardModal = () => {
    setIsDeleteCardModalOpen(false);
    setCardToDelete(null);
  };

  const handleConfirmDelete = () => {
    if (resourceToDelete) {
      if (resourceToDelete.isDefault) {
        setHiddenDefaultResources(prev => {
          const next = { ...prev, [resourceToDelete.cardId]: true };
          saveGroup(resourceToDelete.cardId, { hideDefault: true });
          return next;
        });
      } else {
        setDynamicResources(prev => {
          const next = { ...prev };
          next[resourceToDelete.cardId] = (prev[resourceToDelete.cardId] || []).filter(r => r.id !== resourceToDelete.resourceId);
          saveGroup(resourceToDelete.cardId, { resources: next[resourceToDelete.cardId] });
          // Remove any persisted activation override for the deleted resource
          removeActivationOverride(resourceToDelete.resourceId);
          return next;
        });
      }
    }
    handleCloseDeleteModal();
  };

  const handleConfirmCardDelete = async () => {
    if (cardToDelete) {
      // Fecha o modal imediatamente
      handleCloseDeleteCardModal();

      setResourceUsers(prev => prev.filter(user => user.id !== cardToDelete));
      setDynamicResources(prev => {
        const newDynamicResources = { ...prev };
        delete newDynamicResources[cardToDelete];
        return newDynamicResources;
      });
      setExpandedCards(prev => {
        const newExpandedCards = { ...prev };
        delete newExpandedCards[cardToDelete];
        return newExpandedCards;
      });

      setDomainSelections(prev => {
        const newDomainSelections = { ...prev };
        delete newDomainSelections[cardToDelete];
        return newDomainSelections;
      });
      setHiddenDefaultResources(prev => {
        const newHiddenDefaultResources = { ...prev };
        delete newHiddenDefaultResources[cardToDelete];
        return newHiddenDefaultResources;
      });
      // Remove all persisted activation overrides for resources belonging to this card
      removeActivationOverridesByCard(cardToDelete);
      // Processa a exclusão no backend em background
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/delete_resource_group`, {
          method: 'DELETE',
          headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${accessToken}` },
          body: JSON.stringify({ session_id: sessionId, resource_id: cardToDelete })
        });

        if (!res.ok) {
          const tx = await res.text();
          console.error('Falha ao excluir resource group:', tx);
          // Aqui você poderia mostrar uma notificação de erro e reverter a UI se necessário
        }
      } catch (e) {
        console.error('Erro ao excluir resource group:', e);
        // Aqui você poderia mostrar uma notificação de erro e reverter a UI se necessário
      }
    }
  };

  const handleResourceFieldChange = (cardId, resourceId, field, value) => {
    const resourceKey = `${cardId}-${resourceId}`;

    setResourceFields(prev => ({
      ...prev,
      [resourceKey]: {
        ...prev[resourceKey],
        [field]: value,
      }
    }));

    // Limpa o erro para este campo específico ao digitar
    if (validationErrors[resourceKey]?.[field]) {
      setValidationErrors(prev => {
        const newErrors = { ...prev[resourceKey] };
        delete newErrors[field];
        return {
          ...prev,
          [resourceKey]: newErrors,
        };
      });
    }
  };

  // MODIFICADO - handleSaveResource agora chama saveGroup após validação
  // Função para verificar se todos os campos obrigatórios do recurso estão preenchidos
  const isResourceFieldsFilled = (cardId, resource) => {
    const resourceId = resource.id;
    const resourceKey = `${cardId}-${resourceId}`;
    const config = resourceConfig[resource.name];
    const fieldsState = resourceFields[resourceKey] || {};
    // Verifica se todos os campos obrigatórios estão preenchidos
    const allFieldsFilled = config.fields.every(field => fieldsState[field] && fieldsState[field].trim() !== '');
    // Se houver modelos, verifica se pelo menos um está selecionado
    const selectedResourceModels = selectedModels[resourceKey] || [];
    const modelsFilled = !config.models || selectedResourceModels.length > 0;
    return allFieldsFilled && modelsFilled;
  };
  const handleSaveResource = (cardId, resource) => {
    const resourceId = resource.id;
    const resourceKey = `${cardId}-${resourceId}`;
    const config = resourceConfig[resource.name];
    const fieldsState = resourceFields[resourceKey] || {};
    const errors = {};

    // valida campos normais
    config.fields.forEach(field => {
      if (!fieldsState[field]?.trim()) {
        errors[field] = true;
      }
    });

    // valida modelos (NOVO)
    if (config.models) {
      const selectedResourceModelsObj = selectedModels[resourceKey] || {};

      const modelsWithValue = Object.values(selectedResourceModelsObj)
        .filter(m => m?.value?.trim());

      if (modelsWithValue.length === 0) {
        errors.models = true;
      }
    }

    setValidationErrors(prev => ({
      ...prev,
      [resourceKey]: errors
    }));

    if (Object.keys(errors).length === 0) {

      setResourceActivation(prev => ({
        ...prev,
        [resourceId]: true
      }));

      setActivationOverride(resourceId, true);
      saveGroup(cardId);
    }
  };

  const handleToggleActivation = (resourceId) => {
    // Optimistic UI update
    setResourceActivation(prev => {
      const next = { ...prev, [resourceId]: !prev[resourceId] };
      setActivationOverride(resourceId, !!next[resourceId]);
      return next;
    });

    // Try to persist the change to backend with retries, rollback after N failures
    const deduceCardIdFromResource = (rid) => {
      // resource ids contain the cardId like `llm-<cardId>-<idx>` or `vectorstore-<cardId>` or `storage-<cardId>`
      const parts = rid.split('-');
      // find the first segment that looks like an ObjectId (long string) or numeric timestamp - fallback: second part
      if (parts.length >= 2) return parts[1];
      return null;
    };

    const desiredState = !resourceActivation[resourceId]; // previous value inverted
    const cardId = deduceCardIdFromResource(resourceId);

    // Build minimal updated_data payload targeting the specific resource type
    const buildUpdatedDataForResource = (rid, state) => {
      // Determine type from prefix
      if (rid.startsWith('llm-')) {
        // llm-<cardId>-<idx>
        // The backend expects llm array; we'll send an updated llm array with the specific name/status change
        // Since we don't have full resource details here, we send a minimal shape and rely on backend merge logic.
        return { llm: [{ id: rid, status: state }] };
      }
      if (rid.startsWith('vectorstore')) {
        return { vectorstore: { status: state } };
      }
      if (rid.startsWith('storage')) {
        return { storage_account: { status: state } };
      }
      // fallback: no-op
      return {};
    };

    (async () => {
      const maxAttempts = 3;
      let attempt = 0;
      let success = false;
      const prevValue = !!resourceActivation[resourceId];

      const sleep = (ms) => new Promise(res => setTimeout(res, ms));

      while (attempt < maxAttempts && !success) {
        attempt += 1;
        try {
          const updated_data = buildUpdatedDataForResource(resourceId, desiredState);
          // If we couldn't build a payload, just call saveGroup to persist entire group as fallback
          if (Object.keys(updated_data).length === 0 || !cardId) {
            await saveGroup(cardId || null);
          } else {
            await saveGroup(cardId, updated_data);
          }
          success = true;
        } catch (e) {
          console.warn(`Attempt ${attempt} failed to persist activation for ${resourceId}:`, e);
          // small backoff
          await sleep(500 * attempt);
        }
      }

      if (!success) {
        // rollback optimistic change and persist override accordingly
        setResourceActivation(prev => ({ ...prev, [resourceId]: prevValue }));
        setActivationOverride(resourceId, prevValue);
        console.error(`Failed to persist activation change for ${resourceId} after ${maxAttempts} attempts.`);
      }
    })();
  };

  if (isLoading) {
    return <LoadingSpinner />;
  }

  return (
    <ResourceLayout

      // Dados

      resourceUsers={resourceUsers}

      dynamicResources={dynamicResources}

      domains={domains}

      resourceConfig={resourceConfig}

      resourceFields={resourceFields}

      selectedModels={selectedModels}

      resourceActivation={resourceActivation}

      validationErrors={validationErrors}


      domainSelections={domainSelections}

      expandedCards={expandedCards}


      // State e handlers do popup de novo grupo

      showPopup={showPopup}

      setShowPopup={setShowPopup}

      newBuName={newBuName}

      setNewBuName={setNewBuName}

      handleExitPopup={handleExitPopup}

      handleAddBusinessUnit={handleAddBusinessUnit}

      isSavingBu={isSavingBu}

      popupDomainSelections={popupDomainSelections}


      togglePopupDomainSelection={togglePopupDomainSelection}


      selectedPopupResources={selectedPopupResources}

      setSelectedPopupResources={setSelectedPopupResources}

      formTocado={formTocado}

      blockPopupSave={blockPopupSave}


      // State e handlers do popup de novo recurso

      showResourcePopup={showResourcePopup}

      setShowResourcePopup={setShowResourcePopup}

      newResourceSelections={newResourceSelections}

      setNewResourceSelections={setNewResourceSelections}

      handleAddResources={handleAddResources}

      isSavingResources={isSavingResources}

      resourceListError={resourceListError}

      resourcePopupAttemptedSubmit={resourcePopupAttemptedSubmit}

      editingCardId={editingCardId}

      setEditingCardId={setEditingCardId}

      handleExitResourcePopup={handleExitResourcePopup}


      // Handlers gerais

      handleDeleteCard={handleDeleteCard}

      handleDeleteResource={handleDeleteResource}

      handleToggleActivation={handleToggleActivation}

      handleResourceFieldChange={handleResourceFieldChange}

      handleVerifyAndSaveResource={handleVerifyAndSaveResource}

      handleOpenModelSection={handleOpenModelSection}

      handleExitModelSection={handleExitModelSection}

      showModelSection={showModelSection}

      blockModelSave={blockModelSave}

      isResourceFieldsFilled={isResourceFieldsFilled}

      searchTerm={searchTerm}
      setSearchTerm={setSearchTerm}

      tResource={tResource} // sua função de tradução

      handleModelValueChange={handleModelValueChange}

      handleConfirmCardDelete={handleConfirmCardDelete}
      isDeleteCardModalOpen={isDeleteCardModalOpen}
      handleCloseDeleteCardModal={handleCloseDeleteCardModal}

      handleCloseDeleteModal={handleCloseDeleteModal}
      isDeleteModalOpen={isDeleteModalOpen}
      handleConfirmDelete={handleConfirmDelete}
      availableDomains={availableDomains}
      level={level}
      domainsAccess={domainsAccess}

      alertMessage={alertMessage}
      setAlertMessage={setAlertMessage}
      alertType={alertType}
      setAlertType={setAlertType}
      alertTitle={alertTitle}
      setAlertTitle={setAlertTitle}
      showAlert={showAlert}
      setShowAlert={setShowAlert}
    />
  );
}

export default ResourceContent;